// extracted by mini-css-extract-plugin
module.exports = {"body":"DeckSummaryPanel_body__xnSZ6","type":"DeckSummaryPanel_type__5gFP2","types":"DeckSummaryPanel_types__3UFLz","dark":"DeckSummaryPanel_dark__3ytu7"};